import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamIncompleteExercisesScreen = ({
  track,
  mostRecentExamAttempt,
  pendingPracticalExercises
}) => {
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.practicalsIncomplete"
    }),
    illustration: /*#__PURE__*/_jsx(Illustration, {
      name: "announcement"
    }),
    mostRecentExamAttempt: mostRecentExamAttempt,
    pendingPracticalExercises: pendingPracticalExercises,
    showSecondaryRetakeCTA: true,
    subheading: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "learningCenter.exams.finished.practicalsIncompleteSubheading",
      options: {
        courseName: track && track.name
      }
    }),
    track: track
  });
};
export default ExamIncompleteExercisesScreen;